import { render } from "./DisassociateButton.vue?vue&type=template&id=48a80b7d&scoped=true"
import script from "./DisassociateButton.vue?vue&type=script&lang=js"
export * from "./DisassociateButton.vue?vue&type=script&lang=js"

import "./DisassociateButton.vue?vue&type=style&index=0&id=48a80b7d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a80b7d"]])

export default __exports__